import { Component, Input, ChangeDetectorRef, EventEmitter, Output, forwardRef, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import moment from 'moment-timezone';
import { ButtonTypesEnum } from '@Common/Forms/enums/button-types.enum';
import { DatePickerComponent as AgprDatePickerComponent } from '@Common/Forms/components/DatePicker/date-picker.component';

/* eslint-disable @typescript-eslint/naming-convention */
const EditableValueProvider = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DatePickerComponent),
    multi: true
};

@Component({
    selector: 'agpr-news-date-picker',
    templateUrl: './date-picker.component.html',
    styleUrls: ['./date-picker.component.scss'],
    providers: [EditableValueProvider],
    standalone: false
})
export class DatePickerComponent implements ControlValueAccessor {
    readonly buttonTypes = ButtonTypesEnum;
    @Input() placeholder: string;
    @Input() placeholderIcon: string;
    @Input() calendarDateFormat: string;
    @Input() previewDateFormat: string;
    @Input() showDelete: boolean = false;
    @Input() showMoveButtons: boolean = false;
    @Input() moveUpDisabled: boolean = false;
    @Input() moveDownDisabled: boolean = false;
    @Input() isDisabled: boolean = false;
    @Input() errorsId: string;
    @Output() deleteClick: EventEmitter<any> = new EventEmitter();
    @Output() moveUp: EventEmitter<any> = new EventEmitter();
    @Output() moveDown: EventEmitter<any> = new EventEmitter();

    @ViewChild('calendar') calendar: AgprDatePickerComponent;
    public editable: boolean = false;
    public calendarDate: Date;
    constructor(
        private changeDetector: ChangeDetectorRef,
    ) { }

    registerOnTouched(fn: () => void): void { }
    propagateChange: any = () => { };

    writeValue(value: any): void {
        this.calendarDate = value;
    }

    registerOnChange(fn): void {
        this.propagateChange = fn;
    }


    public onEdit($event): void {
        if (this.isDisabled) {
            return;
        }
        this.editable = true;
        this.changeDetector.detectChanges();
        this.calendar.writeValue(this.calendarDate);
        this.calendar.defaultDate = this.calendarDate;
        this.calendar.panel.updatePanelView();
        this.calendar.showPanel();
    }

    public onDelete($event): void {
        if (this.isDisabled) {
            return;
        }
        this.editable = false;
        this.changeDetector.detectChanges();
        this.deleteClick.emit($event);
    }

    public onMoveUp(): void {
        this.moveUp.emit();
    }
    public onMoveDown(): void {
        this.moveDown.emit();
    }

    public onCalendarClose(): void {
        this.propagateChange(this.calendarDate);
        this.editable = false;
    }

    public onCalendarSelect(newDate: Date): void {
        this.propagateChange(newDate);
        this.editable = false;
    }

    public getFormattedDate(date: Date, dateFormat: string): string {
        const momentDate = moment(date);
        return momentDate.format(dateFormat);
    }
}
